import { MediaTablet } from "api/const/MediaQuery"
import { LoginType } from "components/types/Context"
import useMediaQuery from "hook/useMediaQuery"
import { useContext } from "react"
import { useNavigate } from "react-router-dom"
import { AppGeneralContext } from "shared/GeneralContext/GeneralContext"
import { Button } from "../../atoms"
import { MessageCard } from "../../molecules/MessageCard"

type AskNewAvailabilityProps = {
  name:string,
  fromSender:boolean,
  isOld:boolean,
  startupId: string
}

export const AskNewAvailability = ({startupId, name,fromSender,isOld} : AskNewAvailabilityProps)=>{
   
const {setChatIsOpen, setModalDatesIsOpen, loginType, setstartUpIdforMatch}= useContext(AppGeneralContext)
const tablet = useMediaQuery(MediaTablet)
 const navigate = useNavigate()

  const SelectNewDates= ()=>{
    if(isOld){
      return
    }
    const route = loginType === LoginType.startup ? "start-up" : "corporate"
    setstartUpIdforMatch(startupId);
    setModalDatesIsOpen(true)
    return tablet ?   navigate(`${route}//profile/messaging`) : setChatIsOpen(false)
  }
    return (
        <MessageCard className="" fromSender={fromSender}>
          {fromSender ?
           <p className="p-0 m-0"> You ask for new availability</p>
          :
          <div className="d-flex flex-column">
           <p className="p-0 m-0 mb-3"> <b className="uppercase">{name}</b>  asks for new availability</p>
           <Button
             primary
             disabled={isOld}
              className="chat-button-primary"
              onClick={() => SelectNewDates()} 
              background={"white"}
              text={"CHOOSE DATES"}
              borderColor={"white"}/> 
           </div>
          } 
        </MessageCard>
    )
}